import classNames from "classnames";
import React from "react";

import SVGIcon from "../Images/SVGIcon";
import styles from "./style.module.css";

export const ToastNotificationContainer = ({ currentStep, totalSteps, message }) => {
  return (
    <div className={styles.toastNotificationContainer}>
      <div className={styles.leftColumn}>
        <div className={styles.stepIndicator}>
          <span className={styles.stepIndicatorText}>{currentStep}</span>
        </div>
        <span className={styles.stepIndicatorBar} />
      </div>
      <div className={styles.rightColumn}>
        <span className={styles.title}>
          Step {currentStep} of {totalSteps}
        </span>
        <span className={styles.description}>{message}</span>
        <div className={styles.stepsContainer}>
          {Array.from({ length: totalSteps }, (_, index) => {
            const isCompleted = totalSteps === currentStep || index < currentStep;
            const isUpcoming = currentStep === index + 1 && totalSteps !== currentStep;

            return (
              <div
                key={index}
                className={classNames(styles.stepCircle, {
                  [styles.stepCompleted]: isCompleted,
                  [styles.currentStep]: isUpcoming,
                })}
              >
                {isCompleted && !isUpcoming ? (
                  <SVGIcon src="components/v2/Filters/Dropdown/tick.svg" className={styles.stepCompletedIcon} />
                ) : (
                  <span className={styles.stepCircleText}>{index + 1}</span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
